<template>
  <a-tooltip :title="toolbarTitle">
    <InfoCircleOutlined v-if="toolbarTitle" />
  </a-tooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { NodeType } from "@/app/chatbots/utils/enums";
import { validateNodeType } from "@/app/chatbots/utils/helpers";
import { ChannelType } from "@/app/shared/utils/enums";

const props = defineProps<{ nodeType: number; channelType: number; parentNodeType: number }>();

const toolbarTitle = computed<string>(() => {
  if (validateNodeType(props.nodeType, NodeType.Buttons)) {
    if (props.channelType === ChannelType.Whatsapp)
      return "Esta acción permite solo 3 botones para WhatsApp.";

    return props.parentNodeType === NodeType.CardSection
      ? "Esta acción permite máximo 10 tarjetas. Podrás agregar una imagen, texto y botones en una sola tarjeta."
      : "Esta acción permite un máximo de 13 botones.";
  }

  if (validateNodeType(props.nodeType, NodeType.List)) {
    return "Esta acción permite un máximo de 10 secciones con 10 ítems en total por Lista.";
  }

  if (validateNodeType(props.nodeType, NodeType.Card)) {
    return "Esta acción permite máximo 10 tarjetas. Podrás agregar una imagen, texto y botones en una sola tarjeta.";
  }

  return "";
});
</script>

<style scoped lang="sass"></style>
